module.exports = __webpack_public_path__ + "static/media/BarCouncilIndiaTrust.0e7a703a.jpeg";